import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import styled from 'styled-components';
import { CascadingText } from '../../CascadingText';

export const StyledIconLoading = styled(LoadingOutlined)`
  font-size: 24px;
  position: absolute;
  bottom: 0;
`;

export const IconLabel = styled(Typography.Text)`
  font-size: 16px;
  font-weight: 600;
`;

export const ProcessingLabel = ({
  icon,
  label,
  loading,
}: {
  icon: React.ReactNode;
  label?: string;
  loading: boolean;
}) => {
  return (
    <Flex
      align="center"
      gap={10}
      style={{ position: 'relative', minWidth: 24 }}
    >
      {loading && <StyledIconLoading spin />}
      {icon}
      {label && (
        <IconLabel>
          <CascadingText triggerOnce>{label}</CascadingText>
        </IconLabel>
      )}
    </Flex>
  );
};
